// this is to solve for 100vh on iOS not accounting for address bar height.
// here, measure to see if winHeight is different than 100vh, and if so,
// save a value for var(--vh) that is 1% of the actual window height
export default function () {
    var measure = {
        viewportHeight: function () {
            const vhDiv = document.createElement('div');
            vhDiv.style.position = 'absolute';
            vhDiv.style.height = '100vh';
            document.body.appendChild(vhDiv);

            const vh100Height = vhDiv.scrollHeight;

            document.body.removeChild(vhDiv);

            return vh100Height;
        },
        winHeight: function () {
            return window.innerHeight;
        }
    };


    var fn = {
        init: function () {
            fn.updateViewportHeight();

            // handers
            window.addEventListener('resize', handlers.resize);
            window.addEventListener('orientationchange', handlers.orientationchange);
        },
        updateViewportHeight: function () {
            const vh100Height = measure.viewportHeight();
            const winHeight = measure.winHeight();
            const root = document.documentElement;

            if (vh100Height !== winHeight) {
                root.style.setProperty('--vh', winHeight / 100 + 'px');
            } else {
                root.style.removeProperty('--vh');
            }
        }
    };

    var handlers = {
        resize: function () {
            fn.updateViewportHeight();
        },
        orientationchange: function () {
            fn.updateViewportHeight();
        }
    };

    fn.init();
}
